export default {
  getInfo_aData(aData, idPregunta){
    // esta funcion regresa la infor de aData en base a su  id Pregunta
    return aData.find( registro => {
      if((!!registro) && (registro.IdPregunta == idPregunta)){
        return registro
      }
    })
  },

}